import React, { FC } from 'react';
import Button from '@mui/material/Button';

type Properties = {
  isLogin: boolean;
  onClick: () => void;
};

export const LoginLogoutButton: FC<Properties> = ({ isLogin, onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant='contained'
      sx={{
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: '8px',
        background: isLogin
          ? 'linear-gradient(180deg, #E1F4F5 6.91%, #FBFBFB 90.32%)'
          : 'linear-gradient(90deg, #f44336, #e57373)',
        color: isLogin ? '#000' : '#fff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxHeight: '40px',
        alignSelf: 'center',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 6px 10px rgba(0, 0, 0, 0.15)',
        },
        '&:active': {
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      {isLogin ? 'Login' : 'Logout'}
    </Button>
  );
};
